<template>
  <lu-vbox lu-flex class="app-container">

    <lu-item>
    <PageHeader :title='$t("Sessions")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

    <lu-vbox class='searchBox'>
      <lu-hbox class='searchDivTitle pad-in-5' lu-vcenter lu-click @click='searchExpanded=!searchExpanded'>
        <lu-item lu-click class="el-icon-arrow-right blc-icon" style='font-size:0.85rem;' :class='searchExpanded ? "isActive" : ""'  />
        <lu-item>{{ $t('search.search') }} </lu-item>
      </lu-hbox>

      <template v-if='searchExpanded'>
          <el-form :model='form' ref="form" label-width="150px" class='project' @submit.native.prevent="submitForm('form')">
            <lu-vbox lu-flex-wrap class='lu-hbox'>
              <el-form-item label="Login" prop="login" class='mar-r-20'>
                <el-input v-model="form.login" clearable/>
              </el-form-item>
              <el-form-item label="Between" prop="startDateTime" class='mar-r-20'>
                <el-date-picker
                  clearable
                  v-model="form.startDateTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  style="min-width: 350px;"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop='stillLoggedIn' class='mar-r-20'>
                <el-checkbox label='Still logged in' v-model='form.stillLoggedIn'/>
              </el-form-item>
              <el-form-item label='Result' prop='errorCode' class='mar-r-20'>
                <el-select v-model='form.errorCode' clearable>
                  <el-option label='Success' :value='0'/>
                  <el-option label='Error' :value='1'/>
                </el-select>
              </el-form-item>
            </lu-vbox>
          </el-form>

        <lu-item lu-flex />

         <lu-hbox lu-hcenter class='pad-in-5 mar-t-10 mar-b-10'>
          <lu-item><el-button icon="el-icon-search" @click="handleSearch('form')">{{ $t('action.search') }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-close"  @click="handleCancel('form')">{{ $t('action.cancel') }}</el-button></lu-item>
        </lu-hbox>
      </template>
    </lu-vbox>


<lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
      <el-table
         class='table'
         :data="dataList"
         fit
         striped
         highlight-current-row
         style="width: 100%;"
         @sort-change="sortChange"
         :default-sort = "{prop: 'startDate', order: 'descending'}"
         :row-class-name="tableRowClassName"
      >
          <el-table-column align="center" :label="$t('Session Id')" prop="sessionId" sortable='custom'>
          </el-table-column>
          <el-table-column align="center" :label="$t('Login')" prop="login" sortable='custom'>
          </el-table-column>
          <el-table-column align="center" :label="$t('User Id')" prop="userId" sortable='custom'>
          </el-table-column>
          <el-table-column align="center" :label="$t('Connection date')" sortable='custom' prop="startDate" width='170'>
          </el-table-column>
          <el-table-column align="center" :label="$t('Disconnection date')" sortable='custom' prop="endDate" width='170'>
          </el-table-column>
          <el-table-column align="center" :label="$t('Result')" sortable='custom' prop="errorCode">
            <template slot-scope="scope">
              <el-tag style='width:100px;' size="mini" :type="scope.row.errorCode | statusError" >
                <i :class="statusResult(scope.row.errorCode)" style='margin-right: 5px;' />
                  {{ scope.row.error }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('IP address')" sortable='custom' prop="netAddress">
          </el-table-column>
          <el-table-column align="center" :label="$t('Browser')" sortable='custom' prop="netDevice">
          </el-table-column>

        </el-table>
      </lu-scroll-area>

    <pagination v-show="totalCount>0" :hasDelete='false' :total="totalCount" :page="currentPage" :limit="pageSize" @pagination="getPageFromPagination" />

  </lu-vbox>
</template>
<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import Pagination from '@/components/Pagination'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'
import LibDate from '@/utils/libDate'
import UserAgent from 'useragent'

export default {
  extends: BaseController,
  name: 'sessions',
  components: { Pagination, PageHeader, LuVbox, LuHbox, LuItem, LuScrollArea },
  filters: {
    statusError(error) {
      return error ? 'danger' : 'success'
    }
  },
  data () {
    return {
      searchExpanded: true,
      conditions: [],
      orderBy: 'startDate DESC',
      form: {
        login: '',
        stillLoggedIn: false,
        startDateTime: [],
        errorCode: null
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  mounted: function () {
  },
  computed: {
    ...mapGetters([ 'isAdmin', 'pageSize' ])
  },
  methods: {
    pageControllerName () {
      return 'sessions'
    },
    reload () {

    },
    searchLogin (frm, condList) {
      if (typeof frm === 'undefined') frm = this.form
      if (frm && frm.login) {
        condList.push({ 'field name': 'login', operator: '==', value: [ frm.login ] })
      }
    },
    searchDate (frm, condList) {
      if (typeof frm === 'undefined') frm = this.form
      if (frm.startDateTime.length) {
        let vals = []
        vals.push(LibDate.genDateUTC(frm.startDateTime[0]) + ' 00:00:00')
        vals.push(LibDate.genDateUTC(frm.startDateTime[1]) + ' 23:59:59')
        condList.push({ 'field name': 'startDate', operator: 'between', value: vals })
      }
    },
    searchStillLoggedIn (frm, condList) {
      if (typeof frm === 'undefined') frm = this.form
      if (frm && frm.stillLoggedIn) {
        condList.push({ 'field name': 'endDate', operator: 'null', value: [] })
      }
    },
    searchError (frm, condList) {
      if (typeof frm === 'undefined') frm = this.form
      if (frm && frm.errorCode) {
        condList.push({ 'field name': 'errorCode', operator: '!=', value: [ 0 ] })
      }
    },
    resetForm () {
      this.$refs.form.resetFields()
      this.resultExpanded = false
    },
    getPageFromPagination(val) {
      this.currentPage = val.page
      this.getPage(this.currentPage)
    },
    getPage (page) {
      this.searchData(
        'getSessionList',
        page,
        [
          this.searchLogin,
          this.searchDate,
          this.searchStillLoggedIn,
          this.searchError,
        ],
        null,
        {},
        row => {
          let agent = UserAgent.lookup(row.netDevice)
          row.netDevice = agent ? agent.family + ' / ' + agent.os.family : row.netDevice
          row.error = this.$t(row.errorCode ? 'Error' : 'Success')
          row.userId = row.userId || ''
          let idx = row.netAddress.indexOf(':')
          if (idx !== -1) row.netAddress = row.netAddress.substr(0, idx)
          return true
        },
        null,
        'sessionList'
      )
    },
    handleSearch(formName) {
      if (this.$refs[formName].validate()) {
        this.getPage(1)
      }
    },
    sortChange(data) {
      const { prop, order } = data
      this.orderBy = prop + ' ' + (order === 'ascending' ? 'ASC' : 'DESC')
      this.getPage(this.currentPage)
    },
    handleCancel (formName) {
      this.reset()
      this.conditions = []
      this.$refs[formName].resetFields()
      this.resultExpanded = false
      this.getPage(this.currentPage)
    },
    statusActiveClass (type) {
      if (type === 1) return 'success'
      else if (type === 2 || type === 3) return 'primary'
      else if (type === 4 || type === 5) return 'danger'
      return 'warning'
    },
    statusResult (errorCode) {
      if (errorCode === 0) return 'el-icon-success'
      else return 'el-icon-error'
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
  }
}
</script>